import type { FC } from 'react';
import React from 'react';

import type { PageCardContextProviderProps } from './PageCardContextProvider';
import { CompactEndOfPageView, EndOfPageView } from './Views';
import { AISnippetPageRecExperiment } from './Items/AISnippet/AISnippetPageRecExperiment';

type EndOfPageCardProps = Omit<PageCardContextProviderProps, 'appearance'> & {
	isCompactView?: boolean;
	showCardsAsListitem?: boolean;
};

export const EndOfPageCard: FC<EndOfPageCardProps> = (wrapperProps) => {
	return (
		<AISnippetPageRecExperiment wrapperProps={wrapperProps} isCompactView>
			{() =>
				wrapperProps.isCompactView ? (
					<CompactEndOfPageView showCardsAsListitem={wrapperProps.showCardsAsListitem} />
				) : (
					<EndOfPageView showCardsAsListitem={wrapperProps.showCardsAsListitem} />
				)
			}
		</AISnippetPageRecExperiment>
	);
};
